import { BrandGradientDefs, type IllustrationProps, Sparkle } from "./common";

export function EmptyWorkflows({ size = 120, ...props }: IllustrationProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 200 200"
      width={size}
      height={size}
      fill="none"
      aria-hidden
      {...props}
    >
      <BrandGradientDefs id="ew" />
      {/* Connecting lines */}
      <path
        d="M 60 60 L 100 100 L 60 140"
        stroke="url(#ew-stroke)"
        strokeWidth="2"
        strokeDasharray="4 4"
        fill="none"
        opacity="0.6"
      />
      <path
        d="M 100 100 L 140 60"
        stroke="url(#ew-stroke)"
        strokeWidth="2"
        strokeDasharray="4 4"
        fill="none"
        opacity="0.6"
      />
      <path
        d="M 100 100 L 140 140"
        stroke="url(#ew-stroke)"
        strokeWidth="2"
        strokeDasharray="4 4"
        fill="none"
        opacity="0.6"
      />
      {/* Trigger node */}
      <circle cx="60" cy="60" r="14" fill="hsl(var(--background))" stroke="url(#ew-stroke)" strokeWidth="2" />
      <polygon points="56,54 56,66 68,60" fill="url(#ew-stroke)" />
      {/* Center node */}
      <circle cx="100" cy="100" r="18" fill="url(#ew-fill)" stroke="url(#ew-stroke)" strokeWidth="2.5" />
      <rect x="93" y="93" width="14" height="14" rx="2" fill="url(#ew-stroke)" />
      {/* Branch nodes */}
      <circle cx="140" cy="60" r="12" fill="hsl(var(--background))" stroke="url(#ew-stroke)" strokeWidth="2" />
      <rect x="135" y="55" width="10" height="10" rx="1.5" fill="url(#ew-stroke)" opacity="0.7" />
      <circle cx="140" cy="140" r="12" fill="hsl(var(--background))" stroke="url(#ew-stroke)" strokeWidth="2" />
      <rect x="135" y="135" width="10" height="10" rx="1.5" fill="url(#ew-stroke)" opacity="0.7" />
      <circle cx="60" cy="140" r="12" fill="hsl(var(--background))" stroke="url(#ew-stroke)" strokeWidth="2" />
      <rect x="55" y="135" width="10" height="10" rx="1.5" fill="url(#ew-stroke)" opacity="0.7" />

      <Sparkle cx={160} cy={32} size={8} />
      <Sparkle cx={32} cy={170} size={6} opacity={0.5} />
    </svg>
  );
}
